import PaletteProvider from './paletteProvider'

export default {
    __init__: [
      'paletteProvider'
    ],
    paletteProvider: [ 'type', PaletteProvider ]
};